export const POSITION_OTHER_KEY = 'other';
export const POSITION_ALL_KEY = null;
export const DEFAULT_CACHE_POLICY = 'cache-and-network';
